import { Editors, OptionsProps, SimpleJsonEditor, SimpleOneLineEditor, SimpleOptionsEditor } from "@me8eon/editors";
import React from "react";

export const allEditors: Editors = {
    OneLine: SimpleOneLineEditor,
    Options: SimpleOptionsEditor,
    JsonEditor: SimpleJsonEditor
}
